import { PROCESS } from "../lib/data";

export default function ProcessTimeline() {
  return (
    <section data-testid="process-timeline" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="kicker">Our Process</div>
          <h2 className="mt-3 font-heading text-4xl sm:text-5xl font-black text-navy tracking-tight">
            A disciplined, five-step <br /> engagement model.
          </h2>
        </div>

        <div className="mt-20 relative">
          {/* connector line */}
          <div className="hidden lg:block absolute top-7 left-[7%] right-[7%] h-px bg-steel" />
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-6">
            {PROCESS.map((p, i) => (
              <div
                key={p.step}
                data-testid={`process-step-${p.step}`}
                className="relative flex flex-col items-center text-center group"
              >
                <div className="relative h-14 w-14 rounded-full bg-white border-2 border-steel flex items-center justify-center font-heading font-bold text-navy text-lg z-10 group-hover:border-safety group-hover:bg-safety group-hover:text-white transition-all">
                  {p.step}
                </div>
                <h3 className="mt-6 font-heading text-xl font-bold text-navy">{p.title}</h3>
                <p className="mt-2 text-slate-600 text-sm leading-relaxed max-w-[220px]">{p.desc}</p>
                {i < PROCESS.length - 1 && (
                  <div className="lg:hidden mt-6 h-8 w-px bg-steel" />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
